import React from 'react';
import { useWorkspace } from '../../contexts/WorkspaceContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiMenu, FiBell, FiSearch } = FiIcons;

const Header = ({ onMenuClick }) => {
  const { currentWorkspace } = useWorkspace();

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex items-center">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
          >
            <SafeIcon icon={FiMenu} className="w-6 h-6" />
          </button>
          <div className="hidden lg:block">
            <h1 className="text-2xl font-bold text-gray-900">
              {currentWorkspace?.name || 'QR Suite Pro'}
            </h1>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          {/* Search */}
          <div className="relative hidden md:block">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <SafeIcon icon={FiSearch} className="w-5 h-5 text-gray-400" />
            </div>
            <input
              type="text"
              placeholder="Search QR codes..."
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          {/* Notifications */}
          <button className="p-2 text-gray-400 hover:text-gray-500 hover:bg-gray-100 rounded-md">
            <SafeIcon icon={FiBell} className="w-6 h-6" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;